'use strict'

/**
 * Vue NosMarques
 */

const J_SCROLLTO = '.j_scrollTo'
const J_BACK_TO_TOP_MARQUES = '.j_back_top_marques'

/**
 * Gère la scroll vers les marques de la lettre cliquée
 */
$(function () {
    $(window).scroll(function () {
        const scrollTop = $(window).scrollTop()
        $('.back-top-marques a').click(function () {
            $('html,body').stop().animate({ scrollTop: 0 }, 'slow')
        })
        const div = $(J_BACK_TO_TOP_MARQUES)
        if (scrollTop >= 250) {
            if (div.css('opacity') == 0) {
                div.stop().animate({ opacity: 1 }, 500)
            }
            $('.marque-menu').addClass('marques-fxd')
        } else {
            if (div.css('opacity') > 0) {
                div.stop().animate({ opacity: 0 }, 500)
            }
            $('.marque-menu').removeClass('marques-fxd')
        }
    })

    $(window).scroll()
    $(J_SCROLLTO).on('click', function () {
        // Au clic sur un élément
        const page = $(this).attr('href') // Page cible
        const speed = 550 // Durée de l'animation (en ms)
        const scrollTopv2 = $(window).scrollTop()
        var scrollSize = 0
        if (scrollTopv2 < 250) {
            if ($('.marque-menu').hasClass('scroll-mob')) {
                scrollSize = -50
            } else {
                scrollSize = -75
            }
        }
        $('html, body').animate(
            { scrollTop: $(page).offset().top + scrollSize },
            speed
        ) // Go
        return false
    })
})
